import type { AllocationState, EmployeeStatus } from '@mnc/contracts';

const str = (v: unknown): string | undefined => (typeof v === 'string' && v.trim() ? v : undefined);
const flag = (v: unknown): '1' | undefined => (v === '1' || v === 1 || v === true ? '1' : undefined);
const pageOf = (v: unknown): number | undefined => {
  const n = Number(v);
  return Number.isInteger(n) && n > 1 ? n : undefined;
};

const STATUSES = ['active', 'on_hold', 'left'];
const STATES = ['planned', 'active', 'ended'];

/** URL state of the staff directory. */
export interface PeopleSearch {
  q?: string;
  status?: EmployeeStatus;
  department?: string;
  manager?: string;
  entity?: string;
  over?: '1';
  free?: '1';
  sort?: string;
  page?: number;
}

export function parsePeopleSearch(raw: Record<string, unknown>): PeopleSearch {
  const status = str(raw.status);
  return { q: str(raw.q), status: status && STATUSES.includes(status) ? (status as EmployeeStatus) : undefined, department: str(raw.department), manager: str(raw.manager), entity: str(raw.entity), over: flag(raw.over), free: flag(raw.free), sort: str(raw.sort), page: pageOf(raw.page) };
}

/** URL state of the allocations page. */
export interface AllocationSearch {
  q?: string;
  state?: AllocationState;
  entity?: string;
  employee?: string;
  /** Running allocations that end within 30 days. */
  ending?: '1';
  view?: 'entity';
  sort?: string;
  page?: number;
}

export function parseAllocationSearch(raw: Record<string, unknown>): AllocationSearch {
  const state = str(raw.state);
  return { q: str(raw.q), state: state && STATES.includes(state) ? (state as AllocationState) : undefined, entity: str(raw.entity), employee: str(raw.employee), ending: flag(raw.ending), view: raw.view === 'entity' ? 'entity' : undefined, sort: str(raw.sort), page: pageOf(raw.page) };
}
